/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/react';
import { Component, PropsWithChildren } from 'react';
import { HeaderStyles } from './table-list.styles';

interface IProps extends PropsWithChildren {
  hide?: boolean;
  style?: string | SerializedStyles;
}

export class TableListHeader extends Component<IProps> {
  render() {
    const { children, hide } = this.props;
    return (
      <div
        css={css(
          HeaderStyles.container,
          hide && HeaderStyles.hide,
          this.props.style
        )}
      >
        {children}
      </div>
    );
  }
}
